<template>
  <div class="container materialGRIDetail">
    <div>
      <p class="icon-jujue closeBtn" @click="historyBack"></p>
    </div>
    <el-tabs>
      <el-tab-pane :label="$t('material.searchBox_top')">
        <div class="searchBox_top">
          <!--保存-->
          <el-button v-acl="gri_add" v-if="$route.query.type==='newCreate'||DetailForm.isSave" type="primary" @click="saveDetail(1)">{{$t('common.saveDraft')}}</el-button>
          <!--提交-->
          <el-button v-acl="gri_add" v-if="DetailForm.isSubmit" type="primary" @click="saveDetail(2)">{{$t('common.submit')}}</el-button>
          <el-button v-acl="gri_approval" v-if="DetailForm.isExamine" @click="showApproval = true" type="primary">{{$t('material.showApproval')}}</el-button>
        </div>
        <el-form :model="DetailForm" ref="DetailForm" :rules="DetailRules" label-width="150px" inline>
          <el-row :gutter="20">
            <el-col :span="8">
              <!--GRI编码-->
              <el-form-item :label="$t('material.GRICode')" prop="fiveBitCode">
                <el-input v-model.trim="DetailForm.fiveBitCode" clearable :placeholder="$t('material.DisplayAfterSave')" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!--状态-->
              <el-form-item :label="$t('common.status')" prop="status">
                <ic-select v-model="DetailForm.status" table="TM_FIVE_BIT_CODE" field="STATUS" clearable></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!--创建人-->
              <el-form-item :label="$t('common.createBy')" prop="createUserName">
                <el-input v-model.trim="DetailForm.createUserName" clearable disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!-- Category1 -->
            <el-col :span="8">
              <el-form-item label="Category1" prop="categoryLevel1Id">
                <el-select v-model="DetailForm.categoryLevel1Id" clearable @change="changeCategory1($event)" :disabled="fiveBitCode">
                  <el-option v-for="item in categoryList1" :label="item.name" :value="item.tmCategoryId" :key="item.tmCategoryId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- Category2 -->
            <el-col :span="8">
              <el-form-item label="Category2" prop="categoryLevel2Id">
                <el-select v-model="DetailForm.categoryLevel2Id" clearable :disabled="fiveBitCode" @change="changeCategory2($event)">
                  <el-option v-for="item in categoryList2" :label="item.name" :value="item.tmCategoryId" :key="item.tmCategoryId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- Category3 -->
            <el-col :span="8">
              <el-form-item label="Category3" prop="categoryLevel3Id">
                <el-select v-model="DetailForm.categoryLevel3Id" @change="changeCategory3($event)" clearable :disabled="fiveBitCode">
                  <el-option v-for="item in categoryList3" :label="item.name" :value="item.tmCategoryId" :key="item.tmCategoryId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!--GRI名称-->
            <el-col :span="8">
              <el-form-item :label="$t('material.fiveBitCodeName')" prop="fiveBitCodeName">
                <el-input v-model="DetailForm.fiveBitCodeName" maxlength="50" clearable></el-input>
              </el-form-item>
            </el-col>
            <!--GRI描述-->
            <el-col :span="8">
              <el-form-item :label="$t('material.describe')" prop="describe">
                <el-input type="textarea" maxlength="100" autosize v-model="DetailForm.describe" clearable></el-input>
              </el-form-item>
            </el-col>
            <!--创建日期-->
            <el-col :span="8">
              <el-form-item :label="$t('common.createDate')" prop="createDate">
                <el-date-picker value-format="yyyy-MM-dd" v-model="DetailForm.createDate" type="date" clearable disabled></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!--起始有效日期-->
            <el-col :span="8">
              <el-form-item :label="$t('material.fromEffectiveDate')" prop="fromEffectiveDate">
                <el-date-picker value-format="yyyy-MM-dd" v-model="DetailForm.fromEffectiveDate" type="date" clearable></el-date-picker>
              </el-form-item>
            </el-col>
            <!--无效日期-->
            <el-col :span="8">
              <el-form-item :label="$t('material.invalidDate')" prop="invalidDate">
                <el-date-picker value-format="yyyy-MM-dd" v-model="DetailForm.invalidDate" type="date" clearable></el-date-picker>
              </el-form-item>
            </el-col>
            <!--存货盘点频率-->
            <el-col :span="8">
              <el-form-item :label="$t('material.inventoryCountingFrequency')" prop="inventoryCountingFrequency">
                <ic-select v-model="DetailForm.inventoryCountingFrequency" table="TM_FIVE_BIT_CODE" field="INVENTORY_COUNTING_FREQUENCY" clearable></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!--菜单类别-->
            <el-col :span="8">
              <el-form-item :label="$t('material.menuType')" prop="menuType">
                <ic-select v-model="DetailForm.menuType" table="TM_FIVE_BIT_CODE" field="MENU_TYPE" clearable></ic-select>
              </el-form-item>
            </el-col>
            <!--储存类别-->
            <el-col :span="8">
              <el-form-item :label="$t('material.storageCategory')" prop="storageCategory">
                <ic-select v-model="DetailForm.storageCategory" table="TM_FIVE_BIT_CODE" field="STORAGE_CATEGORY" clearable></ic-select>
              </el-form-item>
            </el-col>
            <!--UOM-->
            <el-col :span="8">
              <el-form-item label="UOM" prop="uom">
                <ic-select v-model="DetailForm.uom" table="TM_FIVE_BIT_CODE" field="UOM" clearable></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!--UOM标准生产份数-->
            <el-col :span="8">
              <el-form-item :label="$t('material.standardCopiesUom')" prop="standardCopiesUom">
                <el-input v-model="DetailForm.standardCopiesUom" :value="DetailForm.standardCopiesUom | toFixed(2)" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <!--在BTR报告中显示-->
            <el-col :span="8">
              <el-form-item :label="$t('material.isDisplayBtrReport')" prop="isDisplayBtrReport">
                <ic-select clearable table="COMMON" field="YES_NO" v-model="DetailForm.isDisplayBtrReport" @change="isDisplayBtrReportChange"></ic-select>
              </el-form-item>
            </el-col>
            <!--BTR使用区域-->
            <el-col :span="8">
              <el-form-item :label="$t('material.btrUsageArea')" prop="btrUsageArea" :class="!isDisabled?'is-required':''">
                <ic-select v-model="DetailForm.btrUsageArea" table="TM_FIVE_BIT_CODE" field="BTR_USAGE_AREA" clearable :disabled="isDisabled"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!--BTR测量单位-->
            <el-col :span="8">
              <el-form-item :label="$t('material.btrUnitMeasurement')" prop="btrUnitMeasurement" :class="!isDisabled?'is-required':''">
                <ic-select v-model="DetailForm.btrUnitMeasurement" table="TM_FIVE_BIT_CODE" field="BTR_UNIT_MEASUREMENT" clearable :disabled="isDisabled"></ic-select>
              </el-form-item>
            </el-col>
            <!-- 是否寄售 -->
            <!-- <el-col :span="8">
              <el-form-item label="是否寄售" prop="isConsignment">
                <ic-select v-model="DetailForm.isConsignment" table="TM_MATERIAL_RECORD" field="IS_NOT" clearable></ic-select>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.approvalLog')">
        <el-table :data="workFlowLogList" border highlight-current-row class="table">
          <el-table-column prop="createDate" :label="$t('common.OperationTime') ">
            <template slot-scope="scope">
              {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}
            </template>
          </el-table-column>
          <el-table-column prop="operatorName" :label="$t('common.OperatorName') "></el-table-column>
          <el-table-column prop="action" :label="$t('common.PedagogicalOperation') "></el-table-column>
          <el-table-column prop="comments" :label="$t('common.opinion') "></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :title="$t('supplierManage.approvalWindow')" :visible.sync="showApproval" width="500px">
      <el-form :model="info" ref="info" class="form_border" label-width="120px">
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('storeFeedback.auditor')" placeholder="">
              <el-input v-model="username" class="handle-input" disabled />
            </el-form-item>

            <el-form-item :label="$t('common.approvalTime') " placeholder="">
              <el-input v-model="date" class="handle-input" disabled />
            </el-form-item>
            <el-form-item :label="$t('common.approvalResults') " placeholder="" prop="approvalType">
              <el-radio v-model="info.approvalType" label="1">{{$t('common.pass')}}</el-radio>
              <el-radio v-model="info.approvalType" label="2">{{$t('common.noPass')}}</el-radio>
            </el-form-item>

            <el-form-item :label="$t('common.approvalRemarks') " placeholder="" prop="approvalDescription">
              <el-input type="textarea" v-model="info.approvalDescription" class="handle-input" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="saveDetail(3)">{{$t('common.submit')}}</el-button>
        <el-button type="primary" @click="showApproval = false">{{$t('common.close')}}</el-button>
      </div>
    </el-dialog>
    <category-dialog :is-show.sync="showDialog" :create-fun="onConfirm" @hideDialog="showDialog = false" />
  </div>

</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { apiService } from "@/api/material/material-master-data";
import GRIApi from "@/api/material/GRI";
import { Message } from "element-ui";
import categoryDialog from "@/components/page/material/material-master-data/category-dialog";

export default {
  components: { IcSelect, categoryDialog },
  data() {
    var validateBtrUsageArea = (rule, value, callback) => {
      if (this.DetailForm.isDisplayBtrReport === 'Y') {
        if (!value) {
          return callback(new Error(this.$t("visitPlan.noEmpty")));
        }
      }
      callback();
    };
    var validateBtrUnitMeasurement = (rule, value, callback) => {
      if (this.DetailForm.isDisplayBtrReport === 'Y') {
        if (!value) {
          return callback(new Error(this.$t("visitPlan.noEmpty")));
        }
      }
      callback();
    };
    return {
      isDisabled: false,
      DetailForm: {
        fiveBitCode: "",
        status: '',
        createUserName: localStorage.getItem("ms_userCd"),
        categoryLevel1Id: '',
        categoryLevel2Id: '',
        categoryLevel3Id: '',
        fiveBitCodeName: "",
        categoryLevel3Name: '',
        describe: "",
        createDate: this.$options.filters["dateFormatFilter"](new Date()),
        fromEffectiveDate: "",
        invalidDate: "",
        inventoryCountingFrequency: "",
        menuType: "",
        uom: '',
        standardCopiesUom: "",
        isDisplayBtrReport: "",
        btrUsageArea: "",
        btrUnitMeasurement: "",
        isConsignment: 'N',
        // approvalDescription: '',
        isSubmit: '',
        isExamine: '',
        isSave: "",
      },
      DetailRules: {
        fiveBitCodeName: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
        describe: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
        categoryLevel1Id: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        categoryLevel2Id: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        status: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        categoryLevel2Id: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        categoryLevel3Name: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
        createDate: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        fromEffectiveDate: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        standardCopiesUom: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
        isDisplayBtrReport: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        btrUsageArea: [
          { validator: validateBtrUsageArea, trigger: 'change' }
        ],
        uom: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        btrUnitMeasurement: [
          { validator: validateBtrUnitMeasurement, trigger: 'change' }
        ],
      },
      categoryList1: [],
      categoryList2: [],
      categoryList3: [],
      fiveBitCode: null,
      tableList: [],
      totalCount: 0,
      showDialog: false,
      showApproval: false,
      info: {
        approvalType: '1',
        approvalDescription: null,
        createBy: null,
        createDate: null
      },// 审批弹框infoFrom
      username: null,
      data: null,
      workFlowLogList: [],//审批日志
    }
  },
  filters: {
    toFixed: function (value, len) {
      if (value) {
        value = Number(value).toFixed(len);
      }
      return value
    }
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.getDetail(this.id)
    }
    this.getCategoryList()
    //审核人：获取当前账号对应账号名称
    // 审核日期：系统当前日期
    this.username = localStorage.getItem("ms_username");
    this.date = this.$options.filters["dateFormatFilter"](new Date())
  },
  methods: {
    isDisplayBtrReportChange(e) {
      if (e === 'N') {
        this.DetailForm.btrUsageArea = ''
        this.DetailForm.btrUnitMeasurement = ''
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    },
    getDetail(id) {
      GRIApi.findOneDetail(id).then((res) => {
        if (res.data) {
          this.changeCategory1('init')
          this.changeCategory2()
          this.DetailForm = res.data
          if (this.DetailForm.isDisplayBtrReport === 'N') {
            this.DetailForm.btrUsageArea = ''
            this.DetailForm.btrUnitMeasurement = ''
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
          //审批日志
          if (res.data.workFlowLogList) {
            this.workFlowLogList = res.data.workFlowLogList
            var isShow = this.workFlowLogList.some(ele => {
              return ele.action === '审批中:提交'
            })
            if (isShow || this.DetailForm.conductStatus === 'under_approval') {
              this.fiveBitCode = true
            } else {
              this.fiveBitCode = false
            }
          }
        }
      });
    },
    saveDetail(type) {
      if (type === 3) {
        if (this.info.approvalType == '2' && !this.info.approvalDescription) {
          Message({ message: this.$t('material.approvalDescription'), type: "warning" });
          return
        }
        this.DetailForm.approvalType = this.info.approvalType
        this.DetailForm.approvalDescription = this.info.approvalDescription
      }
      this.DetailForm.applyType = type
      if (this.DetailForm.status === "DISABLE") {
        var newDate = new Date()
        var obj = {
          y: newDate.getFullYear(),
          m: newDate.getMonth() + 1,
          d: newDate.getDate()
        }
        this.DetailForm.invalidDate = obj.y + '-' + obj.m + '-' + obj.d
        console.log('invalidDate', this.DetailForm.invalidDate);
      }
      this.$refs.DetailForm.validate(valid => {
        if (valid) {
          GRIApi.saveGRI(this.DetailForm).then((res) => {
            if (res.code === '200') {
              if (type == 1) {
                this.id = res.data.tmFiveBitCodeId
                this.getDetail(this.id)
              } else {
                this.historyBack();
              }
              Message({ message: this.$t('common.operateSuccess'), type: "success" });
            } else {
              Message({ message: this.$t('common.operateError'), type: "error" });
            }
          });
        } else {
          return false;
        }
      });
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1(type) {
      console.log("🚀 ~ file: materialGRIDetail.vue:418 ~ changeCategory1 ~ type:", type)
      if (!type) {
        this.DetailForm.categoryLevel2Id = null
      } else {
        var arr1 = this.categoryList1.filter(ele => {
          return ele.tmCategoryId == type
        })
        console.log("🚀 ~ file: materialGRIDetail.vue:425 ~ arr1 ~ arr1:", arr1)
        if (arr1.length > 0) {
          this.$set(this.DetailForm, 'categoryLevel1Code', arr1[0].code)
          this.$set(this.DetailForm, 'categoryLevel1Name', arr1[0].name)
        }
      }
      this.DetailForm.categoryLevel3Id = null
      this.categoryList2 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.DetailForm.categoryLevel1Id }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList2 = res.data;
      });
    },
    //根据选中Category2查询Category3
    changeCategory2(value) {
      var arr2 = this.categoryList2.filter(ele => {
        return ele.tmCategoryId == value
      })
      console.log("🚀 ~ file: materialGRIDetail.vue:446 ~ arr2 ~ arr2:", arr2)
      if (arr2.length > 0) {
        this.$set(this.DetailForm, 'categoryLevel2Code', arr2[0].code)
        this.$set(this.DetailForm, 'categoryLevel2Name', arr2[0].name)
      }
      this.DetailForm.categoryLevel3Id = null
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 3, pid: this.DetailForm.categoryLevel2Id }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList3 = res.data;
      });
    },
    changeCategory3(value) {
      var arr3 = this.categoryList3.filter(ele => {
        return ele.tmCategoryId == value
      })
      console.log("🚀 ~ file: materialGRIDetail.vue:460 ~ arr3 ~ arr3:", arr3)
      if (arr3.length > 0) {
        this.$set(this.DetailForm, 'categoryLevel3Code', arr3[0].code)
        this.$set(this.DetailForm, 'categoryLevel3Name', arr3[0].name)
      }
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    onConfirm: function (data) {
      if (data.categoryLevel3Id) {
        this.DetailForm.categoryLevel3Id = data.categoryLevel3Id
        this.DetailForm.categoryLevel3Name = data.categoryLevel3Name
      }
      this.showDialog = false
    },
    remove3Id() {
      this.DetailForm.categoryLevel3Id = null
    }
  }

}
</script>
<style lang="scss" scoped>
.searchBox_top {
  margin-bottom: 20px;
}

.el-table {
  margin-top: 10px;
}
</style>
<style lang="scss">
.materialGRIDetail {
  .el-form-item {
    width: 400px;

    .el-form-item__content {
      width: 200px;
    }
  }

  .el-select {
    width: 100%;
  }

  .el-date-editor {
    width: 100%;
  }
}
</style>
